export const allStatus = {
  PLANNING: 'PLANNING',
  DELIVERED: 'DELIVERED',
}

export const status = {
  PLANNING: {
    label: 'Planning',
    value: 'PLANNING',
    color: '#C4C4C4',
    bg: 'rgba(196, 196, 196, 0.16)',
  },
  DELIVERED: {
    label: 'Delivered',
    value: 'DELIVERED',
    color: '#2F80ED',
    bg: ' rgba(66, 139, 202, 0.04)',
  },
  ISSUING: {
    label: 'Issuing',
    value: 'ISSUING',
    color: '#9BA3AB',
    bg: 'rgba(155, 163, 171, 0.16)',
  },
  INVOICED: {
    label: 'Invoiced',
    value: 'INVOICED',
    color: '#F0AD4E',
    bg: 'rgba(240, 173, 78, 0.16)',
  },
  PAID: {
    label: 'Paid',
    value: 'PAID',
    color: '#6FCF97',
    bg: 'rgba(111, 207, 151, 0.16)',
  },
}


export const piStatusOptions = [
  { label: 'Planning', value: 'PLANNING', color: '#C4C4C4', bg: 'rgba(196, 196, 196, 0.16)' },
  { label: 'Delivered', value: 'DELIVERED', color: '#2F80ED', bg: ' rgba(66, 139, 202, 0.04)' },
]

export const statusOptions = [
  { label: 'Planning', value: 'PLANNING', color: '#C4C4C4', bg: 'rgba(196, 196, 196, 0.16)' },
  { label: 'Delivered', value: 'DELIVERED', color: '#2F80ED', bg: ' rgba(66, 139, 202, 0.04)' },
  { label: 'Issuing', value: 'ISSUING', color: '#9BA3AB', bg: 'rgba(155, 163, 171, 0.16)' },
  { label: 'Invoiced', value: 'INVOICED', color: '#F0AD4E', bg: 'rgba(240, 173, 78, 0.16)' },
  { label: 'Paid', value: 'PAID', color: '#6FCF97', bg: 'rgba(111, 207, 151, 0.16)' },
]

export const vat = [
  { label: '0%', value: '0' },
  { label: '3%', value: '3' },
  { label: '5%', value: '5' },
  { label: '7%', value: '7' },
  { label: '10%', value: '10' },
  { label: '15%', value: '15' },
]

export const type = [
  { label: 'Service', value: 'SERVICE' },
  { label: 'License', value: 'LICENSE' },
  { label: 'License MA', value: 'LICENSE_MA' },
  { label: 'Subscription', value: 'SUBSCRIPTION' },
  { label: 'Haardware MA', value: 'HARDWARE_MA' },
  { label: 'Hardware', value: 'HARDWARE' },
  { label: 'Other Service', value: 'OTHER_SERVICE' },
  { label: 'CR', value: 'CR' },
]

export const billingType = {
  SERVICE: {
    label: 'Service', value: 'SERVICE',
  },
  LICENSE: {
    label: 'License', value: 'LICENSE',
  },
  LICENSE_MA: {
    label: 'License MA', value: 'LICENSE_MA',
  },
  SUBSCRIPTION: {
    label: 'Subscription', value: 'SUBSCRIPTION',
  },
  HARDWARE_MA: {
    label: 'Hardware MA', value: 'HARDWARE_MA',
  },
  HARDWARE: {
    label: 'Hardware', value: 'HARDWARE',
  },
  OTHER_SERVICE: {
    label: 'Other Service', value: 'OTHER_SERVICE',
  },
  CR: {
    label: 'CR', value: 'CR',
  },
}



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-billing/constants.js